<template>
  <v-card tile flat>
    <v-card-title
      class="subheader font-weight-regular grey--text text--darken-2 pb-0"
    >
      <!-- ACCOUNT BALANCE TOTAL -->
      <v-layout justify-center row wrap class="py-2">
        <v-flex text-xs-center>
          <h1
            align-center
            row
            :class="
              (companyBalance.current_amount >= 0 ? 'ctcGreen' : 'ctcRed') +
              '--text'
            "
          >
            {{ inCurrencyFromId(currencyId, companyBalance.current_amount) }}
          </h1>
          <p align-center class="font-weight-medium font-italic body-2">
            Account Balance
          </p>
        </v-flex>
      </v-layout>
    </v-card-title>

    <v-tabs left v-model="tab" centered height="36" class="pt-0">
      <v-tabs-slider color="primary"></v-tabs-slider>

      <!-- <v-tab>
        <v-icon small>mdi-format-list-bulleted-square</v-icon>
        <span class="font-weight-bold pl-2">Details</span>
      </v-tab> -->

       <v-tab>
        <v-icon small>mdi-view-dashboard</v-icon>
        <span class="font-weight-bold pl-2">Dashboard</span>
      </v-tab>

      <v-tab>
        <v-icon small>mdi-book-open-variant</v-icon>
        <span class="font-weight-bold pl-2">Account Statement</span>
      </v-tab>

      <!-- <v-tab>
        <v-icon small>compare_arrows</v-icon>
        <span class="font-weight-bold pl-2">Reconciliations</span>
      </v-tab> -->

      <v-tab>
        <v-icon small>mdi-bank-transfer</v-icon>
        <span class="font-weight-bold pl-2">Transfers</span>
      </v-tab>

        <!-- <v-tab>
        <v-icon small>mdi-finance</v-icon>
        <span class="font-weight-bold pl-2">Payment Stats</span> -->
      <!-- </v-tab> -->
    </v-tabs>

    <v-card-text>
      <v-tabs-items v-model="tab">
       
       
          <!-- DASAHBOARD -->
        <v-tab-item>
          <v-layout row wrap align-center></v-layout>

          <companyAccountDashboard
            :companyBalance="companyBalance"
            :currencyId="companyBalance.currency_id"
            :companyName="companyBalance.company_name"
            :invoices="companyAccountInvoices"
            :transactions="companyAccountTransactions"
            ref="companyAccountDashboard"
          />
        </v-tab-item>

        <!-- HISTORY -->
        <v-tab-item>
          <v-layout row wrap align-center></v-layout>

          <companyAccountHistory
            :companyBalance="companyBalance"
            :currencyId="companyBalance.currency_id"
            :companyName="companyBalance.company_name"
            :invoices="companyAccountInvoices"
            :transactions="companyAccountTransactions"
            ref="companyAccountHistory"
          />
        </v-tab-item>

        <!-- RECONCILED HISTORY -->
        <!-- <v-tab-item>
          <reconciliationHistoryTree :companyBalanceId="companyBalance.id" />
        </v-tab-item> -->

        <v-tab-item>
          <companyAccountTransfersIndex :companyBalance="companyBalance" />
        </v-tab-item>

         <!-- <v-tab-item>
          <companyPaymentDelayOverview :invoices="companyAccountInvoices" />
        </v-tab-item> -->

        <!-- DEBUG DEV -->
        <!-- <v-tab-item>
          Company Balance:
          <br />
          <json-viewer :value="companyBalance" sort></json-viewer>Invoices:
          <br />
          <json-viewer :value="invoicesList" sort></json-viewer>Transactions:
          <br />
          <json-viewer :value="transactionsList" sort></json-viewer>Sort By Date:
          <br />
          <json-viewer :value="sortInvoicesByDate" sort></json-viewer>
        </v-tab-item>-->
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import JsonViewer from "vue-json-viewer";

import HISTORY_BANK_INVOICES from "../../../graphql/bank_invoices/history.gql";
import INVOICES_INDEX from "../../../graphql/bank_invoices/index.gql";
import TRANSACTIONS_INDEX from "../../../graphql/bank_transactions/index.gql";

import companyAccountHistory from "./companyAccountHistory";
import companyAccountDashboard from "./companyAccountDashboard";
import companyAccountTransfersIndex from "./companyAccountTransfersIndex";
import invoicesDashboard from "./invoicesDashboard";
import reconciliationShow from "../reconciliations/reconciliationShow";
import reconciliationHistoryTree from "../reconciliations/reconciliationHistoryTree";
import transactionListItem from "../transactions/transactionListItem";
import invoiceListItem from "../invoices/invoiceListItem";

import accountingStatus from "../../../mixins/accountingStatus.js";
import currency from "../../../mixins/currency.js";
import date from "../../../mixins/date.js";

export default {
  name: "companyAccountShow",
  components: {
    companyAccountHistory,
    companyAccountTransfersIndex,
    invoiceListItem,
    invoicesDashboard,
    JsonViewer,
    reconciliationShow,
    reconciliationHistoryTree,
    transactionListItem,
    companyAccountDashboard
  },
  mixins: [currency, date, accountingStatus],
  props: {
    companyBalance: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tab: 0,
      loadingInvoices: true,
      loadingUnreconciledInvoices: true,
      loadingTransactions: true,
      loadingHistory: false,
      loadingData: false,
      showHistory: false,
      balanceOperations: [],
      historyPage: 1,
      historyTotalCount: 0,
      displayInvoices: true,
      displayTransactions: true,
      displayTransfers: true,
    };
  },
  computed: {
    ...mapGetters("commonStore", [
      "companyAccountInvoices",
      "companyAccountTransactions",
      "companyAccountNotRecInvoices",
    ]),
    listOfDateEntriesDescendingSort() {
      // First we merge invoices and transactions dates to get all available dates.
      var a = Object.keys(this.sortInvoicesByDate),
        b = Object.keys(this.sortTransactionsByDate);
      // removing duplicate dates
      var c = a.concat(b.filter((item) => a.indexOf(item) < 0));

      return c.sort().reverse();
    },
    currencyId() {
      return this.companyBalance.currency_id;
    },
    sortInvoicesByDate() {
      let obj = {};
      if (this.companyAccountInvoices.length) {
        let unsortedData = this.groupByDate(
          this.companyAccountInvoices,
          "invoice_date"
        );

        for (const [key, value] of Object.entries(unsortedData)) {
          unsortedData[key] = this.sortDateEventsByHour(value, "invoice_date");
        }

        return unsortedData;
      } else return {};
    },
    sortTransactionsByDate() {
      let obj = {};
      if (this.companyAccountTransactions.length) {
        let unsortedData = this.groupByDate(
          this.companyAccountTransactions,
          "payment_date"
        );

        for (const [key, value] of Object.entries(unsortedData)) {
          unsortedData[key] = this.sortDateEventsByHour(value, "payment_date");
        }

        return unsortedData;
      } else return {};
    },
    invoicesFilter() {
      var filter = `company_id == '${this.companyBalance.company.id}' && \
                    currency_id == '${this.companyBalance.currency_id}' && \
                    subsidiary_company_id == '${this.companyBalance.subsidiary_company_id}'`;
      if (this.companyBalance.affiliate_company)
        filter += `&& affiliate_company_id == '${this.companyBalance.affiliate_company.id}'`;
      return filter;
    },
    transactionsFilter() {
      var filter = `company_id == '${this.companyBalance.company.id}' && \
                    bank_transactions.currency_id == '${this.companyBalance.currency_id}' && \
                    bank_information.subsidiary_id == '${this.companyBalance.subsidiary_company.subsidiary.id}'`;
      if (this.companyBalance.affiliate_company)
        filter += `&& affiliate_company_id == '${this.companyBalance.affiliate_company.id}'`;
      return filter;
    },
  },
  methods: {
    sortDateEventsByHour(dateEvents, keyToSort) {
      return dateEvents.sort((a, b) => b[keyToSort] - a[keyToSort]).reverse();
    },
    groupByDate(xs, key) {
      var self = this;
      return xs.reduce(function (rv, x) {
        (rv[self.timeToDateMonthAsText(x[key])] =
          rv[self.timeToDateMonthAsText(x[key])] || []).push(x);

        return rv;
      }, {});
    },
    redirectToCompany(id) {
      var routeToGo = this.$router.resolve({
        name: "company",
        params: { id: id },
      });
      window.open(routeToGo.href, "_blank");
    },
    fetchInvoices() {
      if (!this.companyBalance.company) {
        this.loadingInvoices = false;
        return;
      }
      this.loadingInvoices = true;

      this.fetchAndSubscribe(
        INVOICES_INDEX,
        {
          filter: this.invoicesFilter,
        },
        "commonStore",
        "companyAccountInvoices"
      )
        .then((data) => {
          this.loadingInvoices = false;
        })
        .catch((e) => {
          this.loadingInvoices = false;
        });
    },
    fetchTransactions() {
      if (!this.companyBalance.company) {
        this.loadingTransactions = false;
        return;
      }
      this.loadingTransactions = true;

      this.fetchAndSubscribe(
        TRANSACTIONS_INDEX,
        {
          filter: this.transactionsFilter,
        },
        "commonStore",
        "companyAccountTransactions"
      )
        .then((data) => {
          this.loadingTransactions = false;
        })
        .catch((e) => {
          this.loadingTransactions = false;
        });
    },
    fetchNotReconciliatedInvoices() {
      if (!this.companyBalance.company) {
        this.loadingUnreconciledInvoices = false;
        return;
      }
      this.loadingUnreconciledInvoices = true;
      this.fetchAndSubscribe(
        INVOICES_INDEX,
        { filter: `reconciliation_status != done && ` + this.invoicesFilter },
        "commonStore",
        "companyAccountNotRecInvoices"
      )
        .then((data) => {
          this.loadingUnreconciledInvoices = false;
        })
        .catch((e) => {
          this.loadingUnreconciledInvoices = false;
        });
    },
    fetchData() {
      /* CompanyBlanceTransfers has been fetched within the companyBalance query */
      this.fetchInvoices();
      this.fetchTransactions();
      this.fetchNotReconciliatedInvoices();
    },
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    companyBalance() {
      this.showHistory = false;
      this.tab = 0;
      this.fetchData();
    },
  },
};
</script>
